import React, {useEffect, useRef, useState} from "react";
import "./style.scss";

import {useDispatch, useSelector} from "react-redux";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import AccountInfo from "../../layouts/AccountMetrics/AccountInfo";
import ProgramObjectives from "../../layouts/AccountMetrics/ProgramObjectives";
import TradingJournal from "../../layouts/AccountMetrics/TradingJournal";
import LoaderOverlay from "../../reusableComponents/Loader";
import Tabination from "../../reusableComponents/Tabination";
import {ReactComponent as DropdownArrowIcon} from "../../assets/newIcons/dropdownArrowIcon.svg";
import {getAccountMetrics, setActiveAccount} from "../../store/reducers/accountSlice";
function AccountMetrics() {
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname.split("/")[2];
  const [activeTab, setActiveTab] = useState(0);
  const accountsList = useSelector((state) => state?.account?.accountList);

  const accntListData = accountsList?.data?.find((item) => item?.login_id === accountsList?.active?.replace("%23", "#"));
  const isActive = accntListData?.is_active ?? accountsList?.selectedAccount?.is_active;

  const {brand} = useSelector((state) => state.brand.selectedBrand);

  const idToken = useSelector((state) => state.auth.idToken);
  const selectedAccount = useSelector((state) => state?.account?.accountList?.selectedAccount);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (selectedAccount?.login_id) {
      dispatch(
        getAccountMetrics({
          idToken,
          loginId: selectedAccount.login_id,
          trading_platform: selectedAccount.trading_platform,
          email: selectedAccount.email,
        }),
      );
    }
  }, []);

  const items = [
    {
      name: "Program Objectives",
      path: "program-objectives",
    },

    {
      name: "Trading History",
      path: "trading-history",
    },
    {
      name: "Account Info",
      path: "account-info",
    },
  ];

  useEffect(() => {
    switch (path) {
      case "program-objectives":
        setActiveTab(0);
        break;
      case "trading-history":
        setActiveTab(1);
        break;
      case "account-info":
        setActiveTab(2);
        break;
      default:
        break;
    }
  }, [path]);

  const accountMetrics = useSelector((state) => state.account.accountMetrics);
  const [isLoading, setIsLoading] = useState(accountMetrics.loading);
  const [errorModalOpen, setErrorModalOpen] = useState(accountMetrics.error);

  useEffect(() => {
    setIsLoading(accountMetrics.loading);
  }, [accountMetrics.loading]);
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  const [accntDropdown, setAccntDropdown] = useState(false);
  const [accntFilter, setAccntFilter] = useState(true);
  const [accntFilterList, setAccntFilterList] = useState();

  useEffect(() => {
    if (accntListData) {
      setAccntFilter(accntListData?.is_active);
    }
  }, [accntListData]);

  useEffect(() => {
    // Filter based on active status
    const accountList = accountsList?.data?.filter((item) => item.is_active === accntFilter);
    setAccntFilterList(accountList);
  }, [accntFilter, accountsList?.data]);
  const accountSelectorRef = useRef(null);

  const handleClickOutside = (event) => {
    if (accountSelectorRef.current && !accountSelectorRef.current.contains(event.target)) {
      setAccntDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="accountMetricPageContainer">
      <div className="accountMetricPageWrapper">
        <div className="accountMetricsHeader">
          <Tabination
            variant={7}
            tabItems={items}
            activeTab={activeTab}
          />
          <div className="rightSection">
            {path === "program-objectives" && (
              <>
                {" "}
                <div className={`accountStatusIndicator ${isActive ? "activeStatus" : "inActiveStatus"}`}>
                  <p>{isActive ? "Active" : "Inactive"}</p>
                </div>
                <div
                  className="accountSelectorWrapper"
                  ref={accountSelectorRef}
                >
                  <div
                    className="accountSelector"
                    onClick={() => setAccntDropdown((prev) => !prev)}
                  >
                    <p className={`${brand === "equity_edge" ? "equity_edge" : "crypto_edge"}`}>{accountsList?.active}</p>
                    <DropdownArrowIcon className={`${brand === "equity_edge" ? "equity_edge" : "crypto_edge"}`} />
                  </div>
                  <div className={`accountSelectorDropdown ${accntDropdown === true ? "activeDropdown" : "inactiveDropdown"}`}>
                    <div className="accountFilterOptions" style={{ position: 'relative', zIndex: 1 }}>
                      <div className={`sliding-indicator ${accntFilter === true ? "active" : "inactive"}`} style={{ background: brand === "crypto_edge" ? "var(--brand-theme-color)" : "var(--brand-primary, #36d66b)" }} />
                      <button
                        style={{ position: 'relative', zIndex: 2 }}
                        className={`${brand === "equity_edge" ? "equity_edge" : "crypto_edge"} ${accntFilter === true ? "activeFilter" : ""}`}
                        onClick={() => setAccntFilter(true)}
                      >
                        Active
                      </button>
                      <button
                        style={{ position: 'relative', zIndex: 2 }}
                        className={`${brand === "equity_edge" ? "equity_edge" : "crypto_edge"} ${accntFilter === false ? "inactiveFilter" : ""}`}
                        onClick={() => setAccntFilter(false)}
                      >
                        Inactive
                      </button>
                    </div>
                    <div className="accountSelectorList">
                      {accntFilterList?.map((item) => {
                        return (
                          <div
                            className={`${brand === "equity_edge" ? "equity_edge" : "crypto_edge"}  ${
                              String(accountsList?.active?.replace("%23", "#")) === String(item?.login_id) ? "activeID" : "inactiveID"
                            }`}
                            onClick={() => {
                              dispatch(
                                setActiveAccount({
                                  login_id: item?.login_id?.replace("#", "%23"),
                                  trading_platform: item?.trading_platform,
                                  email: item?.email,
                                }),
                              );
                              setAccntDropdown(false);
                            }}
                          >
                            <p>{item?.login_id}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="accountMetricsContent">
          {(isLoading || accountMetrics.error) && <LoaderOverlay desc={accountMetrics.error && accountMetrics.message} />}
          <Routes>
            <Route
              path="/"
              element={
                <Navigate
                  to="program-objectives"
                  replace={true}
                />
              }
            />
            <Route
              path="program-objectives"
              element={
                <ProgramObjectives
                  errorModalOpen={errorModalOpen}
                  setModalOpen={setErrorModalOpen}
                />
              }
            />
            <Route
              path="trading-history"
              element={
                <TradingJournal
                  errorModalOpen={errorModalOpen}
                  setModalOpen={setErrorModalOpen}
                />
              }
            />
            <Route
              path="account-info"
              element={
                <AccountInfo
                  errorModalOpen={errorModalOpen}
                  setModalOpen={setErrorModalOpen}
                />
              }
            />
            <Route
              path="*"
              element={
                <Navigate
                  to="/"
                  replace={true}
                />
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default AccountMetrics;
